<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">{{
										$t('titles.partnerShips')
									}}</v-card-title>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="shipsTable.additionalFilters"
										:default-sort="shipsTable.defaultSort"
										:excel="false"
										:fields="shipsTable.headers"
										:header-selection-key="'ships-headers'"
										:height="shipsTable.height"
										:total-records="shipsTable.total"
										:filter-save-key="'ships-filters'"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in shipsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
											@contextmenu.prevent="editClick(props.item.id, true)"
										>
											<td
												v-if="shipsTable.selectedHeaders.includes('id')"
												@click="editClick(item.id, false)"
											>
												{{ item.id }}
											</td>
											<td
												v-if="shipsTable.selectedHeaders.includes('name')"
												@click="editClick(item.id, false)"
											>
												{{ item.name }}
											</td>
											<td
												v-if="shipsTable.selectedHeaders.includes('location')"
												@click="editClick(item.id, false)"
											>
												{{ item.location }}
											</td>
											<td
												style="text-align: right"
												v-if="shipsTable.selectedHeaders.includes('price')"
												@click="editClick(item.id, false)"
											>
												{{ item.price_display }}
											</td>
											<td
												v-if="shipsTable.selectedHeaders.includes('active')"
												@click="editClick(item.id, false)"
											>
												<v-icon v-if="item.active" small>fa-check</v-icon>
											</td>
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															v-bind="attrs"
															@click="editClick(item.id, true)"
															v-on="on"
														>
															<v-icon small>fa-external-link-alt</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.openInNewTab') }}</span>
												</v-tooltip>
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'PartnerShips',
	components: { TheTable },
	props: {
		partnerId: [String, Number],
	},
	data: function () {
		return {
			shipsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: '', sortable: false, allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: '', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.locationPort'),
						value: 'location',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.price'),
						value: 'price',
						type: '',
						sortable: false,
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: '',
						width: '100px',
						sortable: false,
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/ships/' + id);
			} else {
				let routeData = this.$router.resolve('/ships/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.shipsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.shipsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'partner-ships/' + this.partnerId,
				request,
				(data, success) => {
					if (success) {
						vm.shipsTable.items = data.items;
						vm.shipsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.shipsTable.height = window.innerHeight - 310 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.ships'), href: '/#/ships', disabled: true }]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
